export enum CreditClaimsStatus {
  APPROVED = 'APPROVED',
  FOR_APPROVAL = 'FOR_APPROVAL',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
  UNDER_REVIEW = 'UNDER_REVIEW',
  SUBMITTED = 'SUBMITTED',
  IN_PROCESS = 'IN_PROCESS',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  COMPLETED = 'COMPLETED',
  REOPENED = 'REOPENED',
  DUPLICATE = 'DUPLliCATE',
  CANCELLED = 'CANCELLED'
}
